import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import T from '../../Locale';
import { toggleModal } from '../../Actions';
import { valueEdit } from './Actions';
const ComponentListItemNew = ({ showCreateModal }) => (_jsx("button", Object.assign({ className: "callout values__category__create", onClick: showCreateModal }, { children: _jsxs("div", Object.assign({ className: "callout__content" }, { children: [_jsx("h1", Object.assign({ className: "text-center" }, { children: "+" })), _jsx("h3", Object.assign({ className: "text-center" }, { children: T.translate('values.create') }))] })) })));
ComponentListItemNew.propTypes = { showCreateModal: PropTypes.func.isRequired };
const mapDispatchToProps = (dispatch) => ({
    showCreateModal: () => {
        dispatch(valueEdit(false));
        dispatch(toggleModal('create-value'));
    }
});
export default connect(null, mapDispatchToProps)(ComponentListItemNew);
